<template>
    <div class="col-md-12 px-0 py-0">
        <div>
            <div class="row">
                <div class="col-md-7">
                    <button
                        type="button"
                        @click="showBody(0)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 0 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Lista
                    </button>
                    <button
                        v-if="phase && phase != 4"
                        type="button"
                        @click="showCreate(1)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 1 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Agregar
                    </button>
                </div>
                <div class="col-md-5 text-right align-top text-success">
                    <span style="font-size: 20px"
                        >Preguntas de calificaciones</span
                    >
                </div>
            </div>

            <question-list-component
                v-if="page == 0"
                v-bind:model_id="model_id"
                @change="callChangeList"
            ></question-list-component>
            <question-form-component
                v-if="page == 1"
                v-bind:parent_id="model_id"
                v-bind:model_id="contest_question_id"
                @change="callChangeCreate"
                :key="componentKey"
            ></question-form-component>
            <question-form-component
                v-if="page == 2"
                v-bind:parent_id="model_id"
                v-bind:model_id="contest_question_id"
            ></question-form-component>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            page: 0,
            contest_question_id: 0,
            componentKey: 0,
            phase: null,
        };
    },
    methods: {
        showCreate() {
            this.contest_question_id = 0;
            this.page = 1;
            this.componentKey += 1;
        },
        showBody(vallue) {
            this.page = vallue;
            this.contest_question_id = 0;
        },
        callChangeList(id) {
            this.contest_question_id = id;
            this.page = 2;
        },
        callChangeCreate() {
            this.page = 0;
        },
        validCreate() {
            let me = this;
            axios
                .get("/admin/contest-question-criteria/validate/" + me.model_id)
                .then(function (response) {
                    me.phase = response.data;
                })
                .catch(function (error) {});
        },
    },
    mounted() {
        this.validCreate();
    },
};
</script>
